var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.display)?_c('div',{staticClass:"loading-dots",class:[_vm.loading ? 'loading-in' : 'loading-out']},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]):_c('div',[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83fbcabe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c-loading.vue
// module id = null
// module chunks = 